import { RootState } from '@app/redux/root-reducer';

export const selectUsersState = (store: RootState) => store.userSlice.users;
export const selectUserDetailState = (store: RootState) => store.userSlice.userDetail;
export const selectAddVendorState = (store: RootState) => store.userSlice.addVendor;
export const selectAddAdminState = (store: RootState) => store.userSlice.addAdmin;
export const selectAddMasterState = (store: RootState) => store.userSlice.addMaster;
export const selectAddressState = (store: RootState) => store.userSlice.address;
export const selectUpdateUserStatusState = (store: RootState) => store.userSlice.updateUserStatus;
